import * as React from 'react';

import BoxLogo from './BoxLogo';

export const boxLogo = () => <BoxLogo />;

export default {
    title: 'Icon/Logo/BoxLogo',
    component: BoxLogo,
    parameters: {
        notes: "`import BoxLogo from 'box-ui-elements/es/icon/logo/BoxLogo';`",
    },
};
